import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { api } from "../../utils/Api";
import RejectAlert from "../../components/Alert/RejectAlert";
import Reject from "./Reject";
import Countdown from "react-countdown";

import DateCountdown from "react-date-countdown-timer";
// import "~react-component-countdown-timer/lib/styles.css";
//toast
import toast from "react-hot-toast";

export default function Dashboard(props) {
  const [working_task, SetWorkingTask] = useState([]);
  const [exposing_working_task, SetExposingWorkingTask] = useState([]);

  const [formData, setFormData] = useState({});
  const [invitition, setInvitition] = useState([]);
  const [company_join, setCompanyJoin] = useState([]);
  const [active, setActive] = useState([]);
  const [reject_modal, SetRejectModal] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });

  const [reject, SetReject] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });

  useEffect(() => {
    console.log("Dashboard On mount :", props);
    get_dashboard();
    get_job_invitations();
    get_Active_Company();
    get_invite();
  }, []);

  async function get_dashboard() {
    //     // }

    // let pass_data: any = {
    //   get: {},
    // };

    // if (history) {
    //   console.log("history", history);
    //   pass_data.get.history = true;
    // }
    // console.log("pass_data", pass_data);
    let response = await api("/dashboard/current_working_task");
    console.log("app_init :", response.response);
    if (response.response.hasOwnProperty("current_regular_working")) {
      SetWorkingTask(response.response.current_regular_working);
    } else {
      SetWorkingTask([]);
    }

    if (response.response.hasOwnProperty("current_hour_working")) {
      SetExposingWorkingTask(response.response.current_hour_working);
    } else {
      SetExposingWorkingTask([]);
    }
  }

  async function get_job_invitations() {
    let response = await api("/company/job_invitations");

    console.log("job_invitations response :", response.response.data);
    setInvitition(response.response.data);
  }

  async function accept_invite(item: any, index: any) {
    let pass_data = {
      post: {
        invitation_id: item.id,
      },
    };
    let data = await api("/company/accept_job_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      if (data.response.hasOwnProperty("message")) {
        toast.error(data.response.message);
      }
      get_job_invitations();
    }
  }

  async function reject_invite(record: any, index: any) {
    let pass_data = {
      post: {
        invitation_id: record,
      },
    };
    let data = await api("/company/reject_job_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      get_job_invitations();
    }
  }

  async function get_invite() {
    //     // }

    // console.log(profileDetails);

    let response = await api("/company/invitations");
    console.log("job_invitations response :", response.response.data);
    setCompanyJoin(response.response.data);
  }

  async function get_Active_Company() {
    //     // }

    let response = await api("/company/get");
    console.log("app_init :", response.response.data);

    setActive(response.response.data);
  }

  async function get_submitFinishForm(id: any) {
    console.log(id);

    var post_data: any = formData;
    console.log("post_data:", post_data);

    post_data.task_id = id;

    console.log("formData :", formData);
    let pass_data = {
      post: post_data,
    };

    let data = await api("/company/finish_task_work", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      get_dashboard();
    }

    console.log("pass_data :", pass_data);
  }

  function input_on_changes(event: any) {
    console.log("input_on_change value", event.target.value);
    console.log("input_on_change value", event.target.name);

    let key_name = event.target.name;
    let key_value = event.target.value;

    setFormData((prevState) => {
      // ...prevState,
      prevState[key_name] = key_value;
      return { ...prevState };
    });
    console.log(formData);
  }

  async function get_submitSellForm(id: any) {
    console.log(id);

    var post_data: any = formData;
    console.log("post_data:", post_data);

    post_data.task_id = id;

    console.log("formData :", formData);
    let pass_data = {
      post: post_data,
    };

    let data = await api("/company/pause_task_work", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      get_dashboard();
    }

    console.log("pass_data :", pass_data);
  }

  async function accept_company_invite(item: any, index: any) {
    let pass_data = {
      post: {
        invitation_id: item.id,
      },
    };
    let data = await api("/company/accept_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      get_invite();
    }
  }

  async function reject_company_invite(record: any, index: any) {
    console.log(record);
    let pass_data = {
      post: {
        invitation_id: record,
      },
    };
    let data = await api("/company/reject_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      get_invite();
    }
  }

  return (
    <div className="container p-3">
      {/* <div className="card" style={{ width: "18rem" }}>
        <div className="card-body">
          {working_task?.map((item: any, index: any) => (
            <>
              <div className="d-flex card-title">
                <h5>{item.task} :</h5>
                <h5>{item.quantity}</h5>
              </div>
              <h6 className="card-subtitle mb-2 text-muted">
                {item.service_name}
              </h6>
              <p className="card-text">{item.company_name}</p>

              <div className="text-muted">{item.created_at}</div>
              <span className="badge bg-primary">{item.task_status}</span>
            </>
          ))}
        </div>
      </div>  */}
      {/* <p>Dashboard Page</p>
      <button
        onClick={() => {
          console.log("Toast Dashboard");
          toast.success("Dashboard Toast");
        }}
      >
        Toast
      </button>
{/* <div className="d-flex mt-4"> */}
      <div className="row">
        <div className="col-lg-4  ">
          <div className="card h-100 mb-3">
            <div className="card-body">
              <div className="mb-3 d-flex ">
                <h5>Job Invititions</h5>
                <div className="ms-auto">
                  <Link
                    to="/work_invite/all/all"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                  >
                    <button type="button" className="btn btn-primary btn-sm">
                      View All
                    </button>
                  </Link>
                </div>
              </div>

              <div className="scrollable">
                {invitition ? (
                  <p className="card-text ">
                    <div
                      id="active-users"
                      role="tabpanel"
                      aria-labelledby="active-users-tab"
                    >
                      {/* <div className="container">
                      <div className="row"> */}
                      {/* <ul className="list-group list-group-flush"> */}
                      <div className="basic-list">
                        {invitition?.map((item: any, index: any) =>
                          item.app_id == 2 ? (
                            <div className="basic-list-item dash-list">
                              <div className="d-flex">
                                <div>
                                  <div className="f-14">
                                    {item.service_name}
                                  </div>

                                  <div>
                                    <h6>{item.event_name}</h6>
                                  </div>

                                  {item.event_starts && (
                                    <p className="text-muted">
                                      <i className="fa-regular fa-clock"></i>{" "}
                                      {item.event_starts} to {item.event_ends}
                                    </p>
                                  )}
                                  {/* <h5>({item.quantity})</h5> */}

                                  {item.event_venue && (
                                    <div>Venue: {item.event_venue}</div>
                                  )}
                                  {item.event_location && (
                                    <div>
                                      <i className="fa-solid fa-location-dot"></i>{" "}
                                      {item.event_location}
                                    </div>
                                  )}

                                  {item.client_name && (
                                    <h6>Client Name : {item.client_name}</h6>
                                  )}
                                </div>

                                {item.event_latitude && item.event_longitude ? (
                                  <div className="ms-lg-auto">
                                    <div className="text-center">
                                      <a
                                        target="_blank"
                                        href={
                                          "https://www.google.com/maps/search/?api=1&query=" +
                                          item.event_latitude +
                                          "%2C" +
                                          item.event_longitude
                                        }
                                      >
                                        <i className="fas fa-directions fs-38"></i>
                                        <div className="text-uppercase mt-1 fs-12">
                                          Get Directions
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div>Exposure pay : {item.amount}</div>

                              <p className="mt-1 fs-14 text-muted">
                                {item.company_name}
                              </p>

                              <div className="text-muted">
                                {item.created_at}
                              </div>

                              {item.hasOwnProperty("rework_message") ? (
                                <div>
                                  <h4>Rework</h4>
                                  <p>Rework Message : {item.rework_message}</p>
                                </div>
                              ) : null}

                              {item.hasOwnProperty("rework_salary_amount") ? (
                                <div>
                                  <p>
                                    Rework Salary Amount :{" "}
                                    {item.rework_salary_amount}
                                  </p>
                                </div>
                              ) : null}

                              <>
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm mt-2 px-3"
                                  onClick={() => {
                                    accept_invite(item, index);
                                  }}
                                >
                                  Accept
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger mx-2 mt-2 px-3"
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal"
                                  onClick={() => {
                                    // delete_service(data, s_index);
                                    SetRejectModal((prevValue) => {
                                      prevValue.is_open = true;
                                      prevValue.title = "invitation";
                                      prevValue.record = item.id;
                                      prevValue.index = index;
                                      return { ...prevValue };
                                    });
                                  }}
                                >
                                  Reject
                                </button>
                              </>
                            </div>
                          ) : (
                            <div className="basic-list-item dash-list">
                              <div className="d-flex pt-3">
                                <div>
                                  <div className="fs-14 fw-bold">
                                    {item.task}
                                  </div>
                                  <div className="fs-14 text-muted">
                                    Sevrice : {item.service_name}
                                  </div>
                                  <div>{item.event_name}</div>
                                  <div>Customer : {item.customer_name}</div>
                                  <div>File Name : {item.client_name}</div>
                                </div>
                                <div className="ms-auto text-center">
                                  <div className="d-flex">
                                    <div className="fs-14">{item.quantity}</div>
                                    <div className="ms-1">Qty</div>
                                  </div>
                                  {item.max_working_hours && (
                                    <div>
                                      max time :{item.max_working_hours} hrs
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p>{item.company_name}</p>
                              <div>
                                <div className="d-flex">
                                  <div className="text-muted">
                                    {item.created_at}
                                  </div>

                                  <div className="ms-auto">
                                    <div className="col card-text">
                                      {item.status == "Accepted" && (
                                        <span className="badge bg-primary">
                                          Accepted
                                        </span>
                                      )}
                                      {item.status == "Rejected" && (
                                        <span className="badge bg-danger">
                                          Rejected
                                        </span>
                                      )}
                                      {item.status == "Deleted" && (
                                        <span className="badge bg-danger">
                                          Deleted
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {item.status == null && (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm mt-2 px-3"
                                      onClick={() => {
                                        accept_invite(item, index);
                                      }}
                                    >
                                      Accept
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger mx-2 mt-2 px-3"
                                      data-bs-toggle="modal"
                                      data-bs-target="#exampleModal"
                                      onClick={() => {
                                        // delete_service(data, s_index);
                                        SetRejectModal((prevValue) => {
                                          prevValue.is_open = true;
                                          prevValue.title = "invitation";
                                          prevValue.record = item.id;
                                          prevValue.index = index;
                                          return { ...prevValue };
                                        });
                                      }}
                                    >
                                      Reject
                                    </button>
                                  </>
                                )}
                              </div>
                              &nbsp;
                            </div>
                          )
                        )}
                      </div>
                      {/* </ul> */}
                      {/* </div>
                    </div> */}
                    </div>
                  </p>
                ) : (
                  <h5 className="text-muted py-5 text-center">
                    No job invitations
                  </h5>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="card h-100 mb-3">
            <div className="card-body">
              {/* <h5 className="card-title">Companies</h5> */}
              <div className="mb-3 d-flex ">
                <h5>Company</h5>
                <div className="ms-auto">
                  <Link
                    to="/activity"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"

                    // className="d-lg-block d-sm-none d-md-none"
                  >
                    <button type="button" className="btn btn-primary btn-sm">
                      View All
                    </button>
                  </Link>
                </div>
              </div>

              <div className="scrollable">
                {active ? (
                  <p className="card-text basic-list">
                    {active.map((item, index) => (
                      <div className="p-2 basic-list-item">
                        <Link
                          className="text-decoration-none text-dark text-decoration-color: black"
                          to={"/company/" + item.id}
                        >
                          <div className="card ">
                            <div className="card-body">
                              <div className="card-title mb-3 fs-14 fw-bold">
                                {item.name}
                              </div>
                              <div className="d-flex">
                                <div className="card-subtitle text-muted fs-14 fw-bold">
                                  {item.app}
                                </div>

                                <div className="col card-text">
                                  <div className="ms-auto text-end">
                                    {item.status == "Rejected" && (
                                      <span className="badge bg-danger">
                                        Rejected
                                      </span>
                                    )}

                                    {item.status == "Deleted" && (
                                      <span className="badge bg-danger">
                                        Deleted
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </p>
                ) : (
                  <h5 className="text-muted py-5 text-center">No Companies</h5>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="card h-100 mb-3">
            <div className="card-body">
              <div className="mb-3 d-flex ">
                <h5>Company Invititions</h5>
                <div className="ms-auto">
                  <Link
                    to="/join_invite/all"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                  >
                    <button type="button" className="btn btn-primary btn-sm">
                      View All
                    </button>
                  </Link>
                </div>
              </div>

              <div className="scrollable">
                {company_join ? (
                  <p className="card-text basic-list">
                    {company_join?.map((item, index) => (
                      <div className="basic-list-item dash-list">
                        <div className="d-flex pt-3">
                          <div>
                            <div className="fs-14 fw-bold">{item.name}</div>
                            <div>{item.message}</div>
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="text-muted pt-3">
                            {item.created_at}
                          </div>
                          <div className="ms-auto">
                            <div className="col card-text">
                              {item.status == "Accepted" && (
                                <span className="badge bg-primary">
                                  Accepted
                                </span>
                              )}

                              {item.status == "Rejected" && (
                                <span className="badge bg-danger">
                                  Rejected
                                </span>
                              )}

                              {item.status == "Deleted" && (
                                <span className="badge bg-danger">Deleted</span>
                              )}
                            </div>
                          </div>
                        </div>
                        {item.status == null && (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary mt-2 btn-sm px-3"
                              onClick={() => {
                                accept_company_invite(item, index);
                              }}
                            >
                              Accept
                            </button>

                            <button
                              type="button"
                              className="btn btn-danger mt-2 mx-2 btn-sm px-3"
                              data-bs-toggle="modal"
                              data-bs-target="#rejectModal"
                              onClick={() => {
                                SetReject((prevValue) => {
                                  prevValue.is_open = true;
                                  prevValue.title = "invitation";
                                  prevValue.record = item.id;
                                  prevValue.index = index;
                                  return { ...prevValue };
                                });
                              }}
                            >
                              Reject
                            </button>
                          </>
                        )}
                        &nbsp;
                      </div>
                    ))}
                  </p>
                ) : (
                  <h5 className="text-muted py-5 text-center">
                    No companies invitations
                  </h5>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div>
        <Link
          to="/work_invite/all/all"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
        >
          <button
            type="button"
            className="btn btn-primary btn-lg mx-2 py-5 px-5"
          >
            Company Task Invitation
          </button>
        </Link>

        <Link
          to="/activity"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"

          // className="d-lg-block d-sm-none d-md-none"
        >
          <button
            type="button"
            className="btn btn-primary btn-lg mx-2 py-5 px-5"
          >
            Companies
          </button>
        </Link>

        <Link
          to="/join_invite/all"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
        >
          <button
            type="button"
            className="btn btn-primary btn-lg mx-2  py-5 px-5"
          >
            Company Join Invitation
          </button>
        </Link>
      </div> */}
      <div className="mt-4 d-lg-flex">
        <div
          className="card col-lg-6 m-2"
          // style={{ minWidth: "30rem", minHeight: "14rem" }}
        >
          <div className="card-body ">
            <h5>Ongoing Task :</h5>
            {working_task.length > 0 ? (
              working_task?.map((item: any, index: any) => (
                <>
                  <div className="d-flex">
                    <div>
                      <div className="fs-14 fw-bold">{item.task}</div>
                      <div className=" fs-14 fw-bold text-muted">
                        Sevrice : {item.service_name}
                      </div>
                    </div>

                    <div className="ms-auto text-center">
                      <div className="d-flex">
                        <div className="fs-14">{item.quantity}</div>
                        <div className="ms-1">Qty</div>
                      </div>
                      {item.max_working_hours && (
                        <div>max time :{item.max_working_hours} hrs</div>
                      )}
                    </div>
                  </div>

                  <h6>{item.event_name}</h6>
                  <h6>Customer : {item.customer_name}</h6>
                  <h6>File Name : {item.client_name}</h6>
                  <p className="card-text">{item.company_name}</p>

                  <div className="text-muted mb-2">{item.created_at}</div>
                  <div className="d-flex">
                    <div>
                      {" "}
                      <Countdown
                        date={Date.now() + item.remaining_duration * 1000}
                      />
                    </div>
                    <div className="ms-auto">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm px-3"
                        data-bs-toggle="modal"
                        data-bs-target="#pauseModal"
                      >
                        Pause
                      </button>
                      {/* <!-- Modal --> */}
                      <div
                        className="modal fade"
                        id="pauseModal"
                        tabindex="-1"
                        aria-labelledby="pauseModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="pauseModalLabel">
                                Pause Work
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <p>Reason</p>
                              <div className="description">
                                <textarea
                                  onChange={(event) => {
                                    input_on_changes(event);
                                  }}
                                  name="reason"
                                  className="form-control"
                                  id="exampleFormControlTextarea1"
                                  rows="3"
                                ></textarea>
                              </div>

                              <br></br>
                              <p>Quantity </p>
                              <input
                                className="form-control"
                                onChange={(event) => {
                                  input_on_changes(event);
                                }}
                                name="quantity"
                                type="text"
                                placeholder=""
                              />
                              <br></br>

                              <p>File Path</p>
                              <input
                                className="form-control"
                                onChange={(event) => {
                                  input_on_changes(event);
                                }}
                                name="file_path"
                                type="text"
                                placeholder=""
                              />
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  console.log("hgfd", formData);
                                  get_submitSellForm(item.id);
                                }}
                              >
                                Save changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-sm btn-success btn-m-2 px-3"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal1"
                      >
                        Finish
                      </button>
                      {/* <!-- Modal --> */}
                      <div
                        className="modal fade"
                        id="exampleModal1"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="exampleModalLabel"
                              >
                                Finish Work{" "}
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <p>Quantity </p>
                              <input
                                className="form-control"
                                onChange={(event) => {
                                  input_on_changes(event);
                                }}
                                name="quantity"
                                type="text"
                                placeholder=""
                              />
                              <br></br>

                              <p>File Path</p>
                              <input
                                className="form-control"
                                onChange={(event) => {
                                  input_on_changes(event);
                                }}
                                name="file_path"
                                type="text"
                                placeholder=""
                              />
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  console.log("hgfd", formData);
                                  get_submitFinishForm(item.id);
                                }}
                              >
                                Finish
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))
            ) : (
              // <div
              //   className="text-muted py-5 text-center"
              //   // style={{ height: "10rem" }}
              // >
              //   <p>No task</p>
              // </div>
              <h5 className="text-muted py-5 text-center">No Tasks</h5>
            )}
          </div>
        </div>
        {/* <h5 className="card-title"> {item.company}</h5> */}
        {/* <h6 className="card-subtitle mb-2 text-muted">Card subtitle</h6> */}
        {/* <h5>({item.quantity})</h5> */}
        {/* <!-- Modal --> */}

        <div
          className="card col-lg-6 m-2"
          // style={{ maxWidth: "55rem", minHeight: "14rem" }}
        >
          <div className="card-body ">
            <h5>Ongoing Exposing Job :</h5>
            {exposing_working_task.length > 0 ? (
              exposing_working_task?.map((item: any, index: any) => (
                <>
                  <div>
                    {/* <h5 className="mb-3">Ongoing Work</h5> */}

                    <div className="card-text ">
                      <div className="d-flex">
                        <div>
                          <div className="f-14">{item.service_name}</div>

                          <div>
                            <h6>{item.event_name}</h6>
                          </div>

                          {item.event_starts && (
                            <p className="text-muted">
                              <i className="fa-regular fa-clock"></i>{" "}
                              {item.event_starts} to {item.event_ends}
                            </p>
                          )}

                          {item.event_venue && (
                            <div>Venue: {item.event_venue}</div>
                          )}
                          {item.event_location && (
                            <div>
                              <i className="fa-solid fa-location-dot"></i>{" "}
                              {item.event_location}
                            </div>
                          )}

                          {item.client_name && (
                            <h6>Client Name : {item.client_name}</h6>
                          )}
                        </div>

                        {item.event_latitude && item.event_longitude ? (
                          <div className="ms-lg-auto">
                            <div className="text-center">
                              <a
                                target="_blank"
                                href={
                                  "https://www.google.com/maps/search/?api=1&query=" +
                                  item.event_latitude +
                                  "%2C" +
                                  item.event_longitude
                                }
                              >
                                <i className="fas fa-directions fs-38"></i>
                                <div className="text-uppercase mt-1 fs-12">
                                  Get Directions
                                </div>
                              </a>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div>Exposure pay : {item.amount}</div>
                      <div className="text-muted">{item.created_at}</div>
                      <p className="card-text">{item.company_name}</p>
                      {item.hasOwnProperty("rework_message") ? (
                        <div>
                          <h4>Rework</h4>
                          <p>Rework Message : {item.rework_message}</p>
                        </div>
                      ) : null}

                      {item.hasOwnProperty("rework_salary_amount") ? (
                        <div>
                          <p>
                            Rework Salary Amount : {item.rework_salary_amount}
                          </p>
                        </div>
                      ) : null}

                      <div className="float-end">
                        <button
                          type="button"
                          className="btn btn-success btn-m-2 btn-sm px-3"
                          data-bs-toggle="modal"
                          data-bs-target="#exposeModal"
                        >
                          Finish
                        </button>

                        <div
                          className="modal fade"
                          id="exposeModal"
                          tabindex="-1"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5
                                  className="modal-title"
                                  id="exampleModalLabel"
                                >
                                  Finish Work{" "}
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body">
                                Are you sure want to finish ongoing task ?
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  data-bs-dismiss="modal"
                                  onClick={() => {
                                    console.log("hgfd", formData);
                                    get_submitFinishForm(item.id);
                                  }}
                                >
                                  Finish
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))
            ) : (
              // <div
              //   className=" text-muted py-5 text-center"
              //   // style={{ height: "10rem" }}
              // >
              //   <p>No task</p>
              // </div>
              <h5 className="text-muted py-5 text-center">No Tasks</h5>
            )}
          </div>
        </div>
      </div>

      <RejectAlert
        open={reject_modal.is_open}
        title={reject_modal.title}
        record={reject_modal.record}
        index={reject_modal.index}
        close={(data) => {
          SetRejectModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete Service : ", data);
            reject_invite(data.value, data.index);
          }
        }}
      />

      <Reject
        open={reject.is_open}
        title={reject.title}
        record={reject.record}
        index={reject.index}
        close={(data) => {
          SetReject((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "reject") {
            console.log("delete Service : ", data);
            reject_company_invite(data.value, data.index);
          }
        }}
      />
    </div>
  );
}
